import React, { useCallback, useEffect, useRef, useState } from 'react';
import axios from 'axios';

// Calendário de feriados (bpo_feriado, o mesmo do VA/VT) num modal reutilizável —
// nasceu para o Painel do Operador editar os feriados sem sair da tela (13/10/2026).
// Nacionais vêm da BrasilAPI pelo botão de importar; municipais/estaduais são
// cadastrados aqui, porque a API da Convenia não expõe o calendário dela.
const API = process.env.REACT_APP_API_BASE;
const TIPOS = { nacional: 'Nacional', estadual: 'Estadual', municipal: 'Municipal' };

const headers = () => ({ Authorization: `Bearer ${localStorage.getItem('access')}` });

const formVazio = (ano) => ({ id: null, data: `${ano}-01-01`, nome: '', tipo: 'municipal', cliente_id: '' });

const CalendarioFeriados = ({ fechar, aoMudar, notificar }) => {
  const [ano, setAno] = useState(new Date().getFullYear());
  const [dados, setDados] = useState(null);
  const [carregando, setCarregando] = useState(false);
  const [salvando, setSalvando] = useState(false);
  const [form, setForm] = useState(formVazio(new Date().getFullYear()));
  const [msg, setMsg] = useState('');
  const mexeu = useRef(false);

  const avisar = (texto) => { setMsg(texto); if (notificar) notificar(texto); };

  const carregar = useCallback((a) => {
    setCarregando(true);
    axios.get(`${API}/api/bpo/feriados/`, { params: { ano: a }, headers: headers() })
      .then((res) => setDados(res.data))
      .catch(() => avisar('❌ Não foi possível carregar o calendário'))
      .finally(() => setCarregando(false));
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => { carregar(ano); }, [ano, carregar]);

  const aposMexer = (texto) => { mexeu.current = true; avisar(`✅ ${texto}`); carregar(ano); };
  const erroDe = (err, padrao) => avisar(`❌ ${err.response?.data?.mensagem || padrao}`);

  const salvar = () => {
    if (!form.nome.trim() || !form.data) { avisar('❌ Informe a data e o nome'); return; }
    setSalvando(true);
    const corpo = { data: form.data, nome: form.nome.trim(), tipo: form.tipo,
      cliente_id: form.cliente_id ? Number(form.cliente_id) : null };
    const req = form.id
      ? axios.patch(`${API}/api/bpo/feriados/`, { id: form.id, ...corpo }, { headers: headers() })
      : axios.post(`${API}/api/bpo/feriados/`, corpo, { headers: headers() });
    req.then((res) => { aposMexer(res.data.mensagem); setForm(formVazio(ano)); })
      .catch((err) => erroDe(err, 'Não foi possível salvar'))
      .finally(() => setSalvando(false));
  };

  const remover = (fer) => {
    axios.delete(`${API}/api/bpo/feriados/`, { params: { id: fer.id }, headers: headers() })
      .then((res) => { aposMexer(res.data.mensagem); if (form.id === fer.id) setForm(formVazio(ano)); })
      .catch((err) => erroDe(err, 'Não foi possível remover'));
  };

  const importar = () => {
    setSalvando(true);
    axios.post(`${API}/api/bpo/feriados/`, { importar_ano: ano }, { headers: headers() })
      .then((res) => aposMexer(res.data.mensagem))
      .catch((err) => erroDe(err, 'Não foi possível importar'))
      .finally(() => setSalvando(false));
  };

  const editar = (fer) => setForm({ id: fer.id, data: fer.data_iso, nome: fer.nome,
    tipo: fer.tipo || 'municipal', cliente_id: fer.cliente_id ? String(fer.cliente_id) : '' });

  const sair = () => { if (mexeu.current && aoMudar) aoMudar(); fechar(); };

  const feriados = dados?.feriados || [];
  return (
    <div className="modal fade show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 10004 }}
      onClick={(e) => { if (e.target === e.currentTarget) sair(); }}>
      <div className="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
        <div className="modal-content shadow-lg">
          <div className="modal-header bg-white">
            <div>
              <h5 className="modal-title" style={{ color: '#212529' }}>
                <i className="fas fa-umbrella-beach me-2" style={{ color: '#f1be48' }} aria-hidden="true"></i>
                Calendário de feriados
              </h5>
              <div className="small" style={{ color: '#6c757d' }}>
                O mesmo calendário do VA/VT — feriado muda dias úteis, crédito e prazos.
              </div>
            </div>
            <button type="button" className="btn-close" onClick={sair} aria-label="Fechar"></button>
          </div>
          <div className="modal-body">
            <div className="d-flex align-items-center justify-content-between flex-wrap gap-2 mb-3">
              <div className="btn-group" role="group" aria-label="Ano">
                <button type="button" className="btn btn-sm btn-light border" onClick={() => setAno(a => a - 1)}>
                  <i className="fas fa-chevron-left" aria-hidden="true"></i></button>
                <span className="btn btn-sm btn-light border fw-bold" style={{ pointerEvents: 'none', minWidth: 70 }}>{ano}</span>
                <button type="button" className="btn btn-sm btn-light border" onClick={() => setAno(a => a + 1)}>
                  <i className="fas fa-chevron-right" aria-hidden="true"></i></button>
              </div>
              <button type="button" className="btn btn-sm btn-outline-primary" onClick={importar} disabled={salvando}
                title="Traz os feriados nacionais do ano (BrasilAPI); os que já existem não duplicam">
                <i className="fas fa-cloud-arrow-down me-1" aria-hidden="true"></i>Importar nacionais de {ano}
              </button>
            </div>

            {/* cadastro / edição */}
            <div className="border rounded p-2 mb-3" style={{ background: '#fcfcfd' }}>
              <div className="row g-2 align-items-end">
                <div className="col-6 col-md-2">
                  <label className="form-label small mb-1" htmlFor="cf-data">Data</label>
                  <input id="cf-data" type="date" className="form-control form-control-sm" value={form.data}
                    onChange={(e) => setForm(fo => ({ ...fo, data: e.target.value }))} />
                </div>
                <div className="col-6 col-md-3">
                  <label className="form-label small mb-1" htmlFor="cf-nome">Nome</label>
                  <input id="cf-nome" className="form-control form-control-sm" value={form.nome} maxLength={120}
                    placeholder="Ex.: Aniversário da cidade" onChange={(e) => setForm(fo => ({ ...fo, nome: e.target.value }))} />
                </div>
                <div className="col-6 col-md-2">
                  <label className="form-label small mb-1" htmlFor="cf-tipo">Tipo</label>
                  <select id="cf-tipo" className="form-select form-select-sm" value={form.tipo}
                    onChange={(e) => setForm(fo => ({ ...fo, tipo: e.target.value }))}>
                    {Object.entries(TIPOS).map(([v, r]) => <option key={v} value={v}>{r}</option>)}
                  </select>
                </div>
                <div className="col-6 col-md-3">
                  <label className="form-label small mb-1" htmlFor="cf-emp">Vale para</label>
                  <select id="cf-emp" className="form-select form-select-sm" value={form.cliente_id}
                    onChange={(e) => setForm(fo => ({ ...fo, cliente_id: e.target.value }))}>
                    <option value="">Todas as empresas</option>
                    {(dados?.clientes || []).map((c) => <option key={c.id} value={c.id}>{c.cliente}</option>)}
                  </select>
                </div>
                <div className="col-12 col-md-2 d-flex gap-1">
                  <button type="button" className="btn btn-sm btn-primary flex-fill" onClick={salvar} disabled={salvando}>
                    <i className={`fas ${form.id ? 'fa-floppy-disk' : 'fa-plus'} me-1`} aria-hidden="true"></i>
                    {form.id ? 'Salvar' : 'Adicionar'}
                  </button>
                  {form.id && (
                    <button type="button" className="btn btn-sm btn-light border" title="Cancelar edição"
                      onClick={() => setForm(formVazio(ano))}><i className="fas fa-xmark" aria-hidden="true"></i></button>
                  )}
                </div>
              </div>
            </div>

            {msg && <div className="small mb-2">{msg}</div>}

            {carregando ? (
              <div className="text-muted small py-3"><i className="fas fa-spinner fa-spin me-2" aria-hidden="true"></i>Carregando o calendário...</div>
            ) : (
              <div className="table-responsive" style={{ maxHeight: 360 }}>
                <table className="table table-sm table-hover align-middle mb-0">
                  <thead className="table-light" style={{ position: 'sticky', top: 0 }}>
                    <tr><th>Data</th><th>Nome</th><th>Tipo</th><th>Vale para</th><th className="text-end">Ações</th></tr>
                  </thead>
                  <tbody>
                    {feriados.map((fer) => (
                      <tr key={fer.id} className={form.id === fer.id ? 'table-active' : undefined}>
                        <td className="tabular" style={{ whiteSpace: 'nowrap' }}>{fer.data}</td>
                        <td>{fer.nome}{fer.cidade ? <span className="text-muted small"> · {fer.cidade}</span> : null}</td>
                        <td className="small text-muted">{TIPOS[fer.tipo] || fer.tipo || '—'}</td>
                        <td className="small">{fer.cliente}</td>
                        <td className="text-end" style={{ whiteSpace: 'nowrap' }}>
                          <button type="button" className="btn btn-sm btn-light border me-1" title="Editar"
                            onClick={() => editar(fer)}><i className="fas fa-pen" aria-hidden="true"></i></button>
                          <button type="button" className="btn btn-sm btn-light border" title="Remover"
                            onClick={() => remover(fer)}><i className="fas fa-trash-can" style={{ color: '#a11d2b' }} aria-hidden="true"></i></button>
                        </td>
                      </tr>
                    ))}
                    {!feriados.length && (
                      <tr><td colSpan={5} className="text-muted small py-3">Nenhum feriado cadastrado em {ano} — importe os nacionais acima.</td></tr>
                    )}
                  </tbody>
                </table>
              </div>
            )}
          </div>
          <div className="modal-footer bg-white d-flex justify-content-between">
            <span className="small text-muted">A Convenia não expõe o calendário pela API — este cadastro vale para VA/VT, ponto e painel.</span>
            <button type="button" className="btn btn-secondary btn-sm" onClick={sair}>Fechar</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CalendarioFeriados;
